/**
 * Checks that the two values are deeply equal.
 *
 * Differs from {@link valuesMatch} by object property value comparison.
 * - valuesMatch returns true only if the properties are the same exact values
 * - deepEquals returns true if the properties are deeply equal
 */
export function deepEquals(a: unknown, b: unknown): boolean {
  if (a === b) return true;

  if (!a || !b) return false;

  if (a instanceof Date) {
    if (!(b instanceof Date)) return false;

    return a.getTime() === b.getTime();
  }

  return typeof a === 'object'
    && typeof b === 'object'
    && Object.keys(a).length === Object.keys(b).length
    && Object.entries(a).every(([key, aValue]) => deepEquals(aValue, (b as { [key]: unknown })[key]));
}